<template>
  <div class="AdditionalGoals">
    <div id="form-div">
      <div class="row">
        <div class="col-md-12 px-4">
          <span>{{ $t('wheelAnalysis.reviewGoals.title') }}</span>

          <div class="sidebar-instructions" style="text-align:left">
            {{ $t('wheelAnalysis.reviewGoals.intro') }}
            <br /><br />
            {{ $t('wheelAnalysis.reviewGoals.q1') }}
            <br /><br />
            {{ $t('wheelAnalysis.reviewGoals.q2') }}
            <br /><br />
            {{ $t('wheelAnalysis.reviewGoals.q3') }}
          </div>

          <br />

          <MDBTextarea
              :disabled="!editMode"
              :label="$t('wheelAnalysis.reviewGoals.notesLabel')"
              rows="5"
              v-model="reviewNotes"
              @blur="allGoalsStore.reviewNotesChanged"
          />

          <!-- Download button -->
          <button class="btn btn-primary mt-2" @click="downloadNotes">
            {{ $t('wheelAnalysis.reviewGoals.downloadNotes') }}
          </button>

          <br />
          <br />

          <div id="sdg-completed">
            {{ $t('wheelAnalysis.reviewGoals.completedMessage') }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_ReviewGoals.js" lang="js"></script>
<style src="./_ReviewGoals.less" lang="less"></style>
